















import { Component, Prop, Vue } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { IImport } from "@/models/imports";
import i18n from "@/i18n";
import _ from "@/boot/lodash";

@Component
export default class UImportedTag extends Vue {
  // Props

  @Prop({ required: true })
  public readonly importObj!: IImport;

  @Prop({ required: true })
  public readonly externalId!: string | number;

  @Prop({ default: () => i18n.t("_.record") })
  public readonly objectType!: TranslateResult;

  @Prop({ default: "is-right" })
  public readonly tooltipPosition!: string;

  // Computed

  public get dateImported() {
    return _.get(this.importObj, "completed_at");
  }

  public get tooltip() {
    return i18n.t("_sentence.imports.imported_from_source_msg", {
      objectType: (this.objectType as string).toLowerCase(),
      source: _.get(this.importObj, "credentials.source.name"),
      hostname: _.get(this.importObj, "credentials.hostname"),
      externalId: this.externalId
        ? `'${this.externalId}'`
        : (i18n.t("_.unknown") as string).toLowerCase(),
      date: this.$moment
        .utc(this.dateImported)
        .local()
        .format(i18n.t("_datetime.date.long") as string)
    });
  }

  // Methods

  public goToImport() {
    this.$router
      .push({
        name: "adminImport",
        params: { importId: _.get(this.importObj, "id") }
      })
      .catch(err => err);
  }
}
